import React, {useEffect, useRef, useState} from 'react'
import {useHistory, useLocation} from "react-router-dom";
import axios from "../../../config/axios";
import {CURRENCY, FLEET_MS_API_URL} from "@constants/index";
import {Card, CardBody, CardHeader, Col, Modal, Row} from "reactstrap";
import JobCard from "@pages/components/JobDetailsComponents/JobCard";
import QuoteComponent from "@pages/components/JobDetailsComponents/QuoteComponent";
import BackActionComponent from "@pages/components/JobDetailsComponents/BackActionComponent";
import {
    CustomHeader,
    CustomInput,
    FleetButton,
    FlexInnerComponent
} from "@pages/new-design-components/custom-components";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import ServiceRecordPreviewComponent from "@pages/components/JobDetailsComponents/ServiceRecordPreviewComponent";
import ServiceRecordComponentForPrint from "@pages/components/JobDetailsComponents/ServiceRecordComponentForPrint";
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";
import QuotePreviewComponentForPrint from "@pages/components/JobDetailsComponents/QuotePreviewComponentForPrint";
import {LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import notify from "@utils/notify";

export default function AddVehicleRepairQuote() {
   const location = useLocation();
   const [loading,setLoading] = useState(true);
   const [generating,setGenerating] = useState(false);
   const [inspectionRecord,setShowInspectionRecord] = useState(false);
   const [imageModal,setImageModal] = useState({
       isOpen: false,
       imageUrl: null,
   });
   const [vehicle,setVehicle] = useState({});
   const [departments,setDepartments] = useState([]);
   const [data,setData] = useState([]);
   const [invoiceData,setInvoiceData] = useState([]);
   const [damages,setDamages] = useState([]);
   const [inspectionData,setInspectionData] = useState([]);
   const [partsData,setPartsData] = useState([]);
   const [noInsurance,setNoInsurance] = useState(false);
   const [quote,setQuote] = useState({
       sum: null,
       discount: null,
       total: null
   });
   const history = useHistory();
   const queryParams = new URLSearchParams(location.search);
   const vehicleId = queryParams.get('vehicleId');
   const fleetId = queryParams.get('fleetId');
   const quoteId = queryParams.get('quoteId');
    const calculateSum = () => {
        const dataSum = data.reduce((acc, item) => {
            const cost = parseFloat(item.cost);
            return acc + (isNaN(cost) ? 0 : cost);
        }, 0);

        const partsDataSum = partsData.reduce((acc, item) => {
            const cost = parseFloat(item.cost);
            return acc + (isNaN(cost) ? 0 : cost);
        }, 0);

        return dataSum + partsDataSum;
    };
    useEffect(() => {
        const sum = calculateSum();
        const total = calculateTotalWithDiscount(sum,quote?.discount)
        setQuote({...quote,sum:sum,total:total })
    }, [data, partsData]);

    useEffect(() => {
        if (fleetId && vehicleId) {
            axios({
                method: 'GET',
                url: `${FLEET_MS_API_URL}/fleet-management/fleet-quote-details`,
                params: {
                    quoteId,
                    fleetId,
                    vehicleId,
                },
            }).then(res=>{
                const q = res.data.data
                setQuote(q)
                setPartsData(q.parts)
                fetchData(q.vehicle_id,q.fleet_id, q.work)
                setInvoiceData(q.work.filter(item=>item.added_to_report))
            }).catch(err=>{
                console.log('err:',err)
            })
        }
    },[quoteId,vehicleId,fleetId])

    const fetchData = (vehicleId,fleetId,work = []) => {
        axios({
            method: 'GET',
            url: `${FLEET_MS_API_URL}/fleet-management/fleet-vehicle`,
            params: {
                vehicleId,
                fleetId,
            }
        }).then(res=>{
            const tempData = res.data.data
            setNoInsurance(tempData?.insureance_written_off)
            axios({
                method: 'GET',
                url: `${FLEET_MS_API_URL}/fleet-management/get-required-inspection`,
            }).then(resource=>{
                setDamages(tempData.damages)
                setData(work)
                let requiredData = resource.data.data;
                requiredData = requiredData.map(item => {
                    item.list = item.list.map(listItem => {
                        tempData.requiredInspectionResult.map(res=>{
                            if (res?.required_inspection_id === listItem.id) {
                                listItem.option_id = res.id;
                                listItem.required = res?.required === 1;
                            }
                        })
                        return listItem;
                    });
                    return item;
                });
                setInspectionData(requiredData)
                setLoading(false)
            }).catch(()=>{
                setLoading(false)
            })
        }).catch(()=>{
            setLoading(false)
        })
    }


   useEffect(()=>{
      if (vehicleId) {
         try {
           axios({
               method: 'GET',
               url: `${FLEET_MS_API_URL}/fleet-management/fleet-quote-vehicle`,
                 params: {
                    vehicleId,
                 },
            }).then(res=>{
               const data = res.data.data
               setVehicle(data.vehicle)
               setDepartments(data.departments)
               setLoading(false)
           }).catch(()=>{
              setLoading(false)
           })

         } catch (error) {
            setLoading(false)
            if (axios.isCancel(error)) {
               console.log('Request canceled :: ', error)
            } else {
               console.error('error :: ', error)
            }
         }
      }
   },[vehicleId])



    const redirectToManagement = () => {
        history.goBack();
    }
    const generateQuote = async () => {
        const response = await axios.post(`${FLEET_MS_API_URL}/fleet-management/generate-quote`,{
            id: quote?.id
        })
        if (response.status === 200)
        {
            setGenerating(false)
            notify.success( 'Successfully Created ')
        } else {
            setGenerating(false)
            notify.warning('Something went wrong please try again later!');
        }
    }


    const calculateTotalWithDiscount = (sum, discount = 0) => {
        return sum + (sum * (discount / 100));
    };

    const handleGeneratePDF = () => {
        const input = document.getElementById('pdf-content-component');

        html2canvas(input, {
            scale: 1,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF('l', 'mm', 'a4');
            let pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            let imgHeight = (canvas.height * pdfWidth) / canvas.width;

            if (imgHeight > pdfHeight) {
                imgHeight = pdfHeight;
            }

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save('generated-pdf.pdf');
        });
    };
    const sendPdf = () => {
        const input = document.getElementById('pdf-content-component');

        html2canvas(input, {
            scale: 1,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png',0.5);
            const pdf = new jsPDF('l', 'mm', [220, 500]);
            let pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            let imgHeight = (canvas.height * pdfWidth) / canvas.width;

            if (imgHeight > pdfHeight) {
                imgHeight = pdfHeight;
            }
            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            const pdfBlob = pdf.output('blob');
            const formData = new FormData();
            const pdfFileName = `vehicle_${vehicleId}_generated.pdf`;
            formData.append('vehicle_id', vehicleId);
            formData.append('type', 'service_report');
            formData.append('pdf', pdfBlob, pdfFileName);
            axios({
                method: 'POST',
                url: `${FLEET_MS_API_URL}/fleet-management/save-report`,
                data: formData
            }).then(()=>{
                notify.success('Successfully generated')
            }).catch(()=>{
                notify.warning('Quote did not generated!');
            })
        });
    };

    const sendQuotePdf = () => {
        setGenerating(true)
        const input = document.getElementById('pdf-content'); // The content you want to convert to PDF
        html2canvas(input, {
            scale: 1,
        }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png',0.5);

            const pdf = new jsPDF('p', 'mm', [220, 500]);
            let pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            let imgHeight = (canvas.height * imgWidth) / canvas.width;

            if (imgHeight > pdfHeight) {
                imgHeight = pdfHeight;
            }

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);

            const pdfBlob = pdf.output('blob');

            const formData = new FormData();

            const pdfFileName = `vehicle_${vehicleId}_generated.pdf`;
            formData.append('vehicle_id', vehicleId);
            formData.append('email', vehicle?.email);
            formData.append('customer_id', vehicle?.customer_id);
            formData.append('quote_id', quoteId);
            formData.append('fleet_id', fleetId);
            formData.append('status', 'sent');
            formData.append('total', quote?.total);
            formData.append('pdf', pdfBlob, pdfFileName);
            formData.append('type', 'repair_report');
            axios({
                method: 'POST',
                url: `${FLEET_MS_API_URL}/fleet-management/save-report`,
                data: formData
            }).then(()=>{
                generateQuote();
            }).catch(()=>{
                setGenerating(false)
                notify.warning('Something went wrong please try again later!');
             })
        });
    };
    const toggleImageModal = () => {
        setImageModal({...imageModal,isOpen: !imageModal.isOpen})
    }
    const viewImageModal = (url) => {
        setImageModal({isOpen: true,imageUrl: url})
    }
    const updateFleet = async () => {
        try {

            const response = await axios({
                method: 'POST',
                url: `${FLEET_MS_API_URL}/fleet-management/fleet-insureance-update/${fleetId}`,
                data: {
                    insureance_written_off: !noInsurance,
                },
            })
            if (response.status === 200) {
              setNoInsurance(!noInsurance)
                notify.success('Successfully updated');
            }

        }catch (e) {
            notify.warning('Something went wrong please try again later!');
        }
    }
   return (
       loading ?  <LoaderContainer>
               <ClipLoader
                   css={override}
                   size={40}
                   color={`#7B61E4`}
                   loading={loading}
               />
           </LoaderContainer>
           :
           <div className={'container-fluid mt-3'}>
               <Modal isOpen={imageModal.isOpen} className={'modal-dialog-centered modal-lg'} toggle={toggleImageModal}>
                   <img src={imageModal.imageUrl} width={'100%'} alt=""/>
               </Modal>
               <div className="rna-wrapper">
                   <QuotePreviewComponentForPrint
                       data={invoiceData}
                       quote={quote}
                       vehicle={vehicle}
                       inspectionData={inspectionData}
                       damages={damages}
                       parsable={true}/>
               </div>
               {
                   inspectionRecord ? <>
                           <ServiceRecordPreviewComponent backToList={()=>{setShowInspectionRecord(false)}}
                                                          vehicle={vehicle}
                                                          vehicleId={vehicleId}

                                                          sendPdf={sendPdf}
                                                          handleGeneratePDF={handleGeneratePDF}
                                                          partsData={partsData.filter(item=>item.added_to_report)}
                                                          data={data.filter(item=>item.added_to_report)}
                                                          totalLabour={data.filter(item=>item.added_to_report)?.reduce((accumulator, part) => {
                                                              return accumulator + (parseFloat(part.hour));
                                                          }, 0)}
                                                          dataTotal={data.filter(item=>item.added_to_report)?.reduce((accumulator, part) => {
                                                              return accumulator + (part.cost);
                                                          }, 0)}
                                                          total={partsData.filter(item=>item.added_to_report)?.reduce((accumulator, part) => {
                                                              return accumulator + part.cost;
                                                          }, 0)}
                           />
                           <ServiceRecordComponentForPrint
                               parsable={true}
                               vehicle={vehicle}
                               partsData={partsData.filter(item=>item.added_to_report)}
                               data={data.filter(item=>item.added_to_report)}
                               totalLabour={data.filter(item=>item.added_to_report)?.reduce((accumulator, part) => {
                                   return accumulator + (parseFloat(part.hour));
                               }, 0)}
                               dataTotal={data.filter(item=>item.added_to_report)?.reduce((accumulator, part) => {
                                   return accumulator + (part.cost);
                               }, 0)}
                               total={partsData.filter(item=>item.added_to_report)?.reduce((accumulator, part) => {
                                   return accumulator + (part.cost);
                               }, 0)}
                           />
                       </>
               :   <>
                           <BackActionComponent backAction={redirectToManagement} text={'Back to overview'}/>
                           <div className={'d-flex justify-content-between flex-wrap'}>
                               <CustomHeader lineHeight={'unset'} >{location.pathname === '/admin/job-card' ? 'Job Card' : 'Repair Quote'} </CustomHeader>
                           </div>
                           <Row className={'mt-4'}>
                               <Col lg={3}>
                                   <JobCard data={vehicle} noInsurance={noInsurance} updateFleet={updateFleet}/>
                                   <Card className={'fleet-details-container'}>
                                       <CardHeader className={'border-bottom-0'}>
                                           <div className={'d-flex justify-content-between'}>
                                               <CustomHeader fontSize={'16px'}>
                                                   Quote Total
                                               </CustomHeader>

                                           </div>
                                       </CardHeader>
                                       <CardBody>
                                           <div className={'d-flex justify-content-between align-items-center'}>
                                               <FlexInnerComponent  width={'20'}>
                                                   <CustomHeader lineHeight={'none'} fontSize={'14px'} weight={'600'} color={'#0000008C'}>
                                                       Sum
                                                   </CustomHeader>
                                               </FlexInnerComponent>

                                               <FlexInnerComponent width={'70'}>
                                                   <CustomHeader  lineHeight={'none'} fontSize={'14px'} weight={'400'} color={'#000000'}>
                                                       {CURRENCY}  {quote?.sum}
                                                   </CustomHeader>
                                               </FlexInnerComponent>

                                           </div>
                                           <div className={'d-flex justify-content-between align-items-center'}>
                                               <FlexInnerComponent  width={'30'}>
                                                   <CustomHeader lineHeight={'none'} fontSize={'14px'} weight={'600'} color={'#0000008C'}>
                                                       Discount  %
                                                   </CustomHeader>
                                               </FlexInnerComponent>

                                               <FlexInnerComponent width={'60'}>
                                                   <CustomInput radius={'8px'}
                                                                onChange={(e)=>{
                                                                    const total = calculateTotalWithDiscount(quote?.sum,e.target.value)
                                                                    setQuote({...quote,discount:e.target.value,total: total})
                                                                 }
                                                                }
                                                                border={'1px solid #C0D9FF59'}
                                                                value={quote?.discount} />
                                               </FlexInnerComponent>

                                           </div>
                                           <div className={'d-flex justify-content-between align-items-center'}>
                                               <FlexInnerComponent  width={'20'}>
                                                   <CustomHeader lineHeight={'none'} fontSize={'14px'} weight={'600'} color={'#0000008C'}>
                                                       Sum
                                                   </CustomHeader>
                                               </FlexInnerComponent>

                                               <FlexInnerComponent width={'70'}>
                                                   <CustomHeader  lineHeight={'none'} fontSize={'14px'} weight={'750'} color={'#000000'}>
                                                       {CURRENCY}  { quote?.total}
                                                   </CustomHeader>
                                               </FlexInnerComponent>

                                           </div>
                                       </CardBody>
                                       <div className={'d-flex w-100 align-items-center justify-content-center mb-3'}>
                                           <FleetButton
                                               height={'40px'}
                                               width={'90%'}
                                               disabled={generating}
                                               backgroundColor={'#000'}
                                               radius={'24px'}
                                               onClick={sendQuotePdf}
                                           >
                                               Generate Quote
                                           </FleetButton>
                                       </div>
                                   </Card>

                               </Col>
                               <Col lg={9}>
                                   <QuoteComponent departments={departments}
                                                   initialData={data}
                                                   fleetId={fleetId}
                                                   quote={quote}
                                                   vehicleId={vehicleId}
                                                   damages={damages}
                                                   viewImage={viewImageModal}
                                                   setShowInspectionRecord={()=>{setShowInspectionRecord(true)}}
                                                   initialPartsData={partsData}
                                                  />
                               </Col>
                           </Row>
                       </>
               }

           </div>
   )
}